import { datadogRum } from '@datadog/browser-rum';

export async function fetchContent(query: string) {
  const env = process.env.GATSBY_CONTENTFUL_ENVIRONMENT;
  const space = process.env.GATSBY_CONTENTFUL_SPACE;
  const accessToken = process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN;

  try {
    const res = await fetch(`https://graphql.contentful.com/content/v1/spaces/${space}/environments/${env}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ query, variables: { preview: false } }),
    });
    if (!res.ok) {
      throw new Error(`There was a problem retrieving entries with the query ${query}. Error: ${JSON.stringify(res)}`);
    }
    const { data } = await res.json();
    return data;
  } catch (error) {
    datadogRum.addError(error);
    return error;
  }
}

export async function getAllBrokerList(): Promise<{ label: string; value: string }[]> {
    try {
      const res = await fetchContent(
        `
        query {
          brokerCollection(limit: 1500, order: name_ASC){
            items{
              name
              id
            }
          }
        }
      `);
      return res.brokerCollection.items.map((item: { name: string; id: string }) => ({
        label: item.name,
        value: item.id,
      }));
    } catch (error) {
      datadogRum.addError(error);
      return [];
    }
  }